import React from 'react';
import './InfiniteListLoadIndicator.scss';
import Classnames from 'classnames';

function InfiniteListLoadIndicator({ theme, children, endOfList }) {
  return children ? (
    <div
      className={Classnames(
        'infinite-list-load-indicator',
        `infinite-list-load-indicator--${theme}`,
        {
          'infinite-list-load-indicator--list-end': endOfList,
        }
      )}
    >
      {children}
    </div>
  ) : null;
}

export default InfiniteListLoadIndicator;
